<div class="image-comparison" (mousemove)="onMouseMove($event)" (mouseleave)="onMouseLeave($event)">
    <input type="range" class="slider" min="0" max="100" [value]="sliderValue" readonly>
    <div class="image-container">
        <img [src]="originalImage" [alt]="originalAlt" class="original-image">
        <img [src]="effectImage" [alt]="effectAlt" class="effect-image"
            [style.clip-path]="getClipPath()">
    </div>
</div>
